import React from 'react';
import '../styles/Hero.css';

function Hero() {
  const smoothScroll = (e, targetId) => {
    e.preventDefault();
    const target = document.querySelector(targetId);
    if (target) {
      target.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  };

  return (
    <section className="hero" id="home">
      <div className="floating-element">△</div>
      <div className="floating-element">○</div>
      <div className="floating-element">△</div>
      
      <div className="hero-content">
        <div className="logo">
          <div className="triangle"></div>
          <h1>TRÔ YOGA</h1>
          <p className="hero-subtitle">THE POWER OF NEUTRALITY</p>
        </div>
        <h2 className="hero-description">Power Yoga • Vinyasa Flow • AI-Guided Practice</h2>
        <div className="cta-buttons">
          <a 
            href="#ai-chat" 
            className="btn btn-primary"
            onClick={(e) => smoothScroll(e, '#ai-chat')}
          >
            Try TRO AI Chat
          </a>
          <a 
            href="#power-yoga" 
            className="btn btn-secondary"
            onClick={(e) => smoothScroll(e, '#power-yoga')}
          >
            Explore Power Yoga
          </a>
        </div>
      </div>
    </section>
  );
}

export default Hero;
